import * as api from '../../../clients/vorlagen';

import {Action} from '@ngrx/store';

export const POST_AUFGABE_BILD_HINZUFUEGEN = '[VorlagenModul] PostAufgabeBildHinzufuegen laden';
export const POST_AUFGABE_BILD_HINZUFUEGEN_AUSFUEHREN = '[VorlagenModul] PostAufgabeBildHinzufuegen ausführen';
export const POST_AUFGABE_BILD_HINZUFUEGEN_ERFOLGREICH = '[VorlagenModul] PostAufgabeBildHinzufuegen laden erfolgreich';
export const POST_AUFGABE_BILD_HINZUFUEGEN_FEHLER = '[VorlagenModul] PostAufgabeBildHinzufuegen Ladefehler';
export const POST_AUFGABE_BILD_HINZUFUEGEN_NICHT_AUSGEFUEHRT = '[VorlagenModul] PostAufgabeBildHinzufuegen nicht ausgeführt (evtl. Offline)';


export class PostAufgabeBildHinzufuegenAction implements Action {
    readonly type = POST_AUFGABE_BILD_HINZUFUEGEN;
        constructor(public aufgabeBildRequest: api.AufgabeBildRequest, public optPayload: any = null) {}
    }
export class PostAufgabeBildHinzufuegenAusfuehrenAction implements Action {
    readonly type = POST_AUFGABE_BILD_HINZUFUEGEN_AUSFUEHREN;
        constructor(public aufgabeBildRequest: api.AufgabeBildRequest, public optPayload: any = null) {}
    }
export class PostAufgabeBildHinzufuegenErfolgreichAction implements Action {
    readonly type = POST_AUFGABE_BILD_HINZUFUEGEN_ERFOLGREICH;
        constructor(public payload: api.AufgabeIdentifier, public aufgabeBildRequest: api.AufgabeBildRequest, public optPayload: any = null) {}
    }
export class PostAufgabeBildHinzufuegenFehlerAction implements Action {
    readonly type = POST_AUFGABE_BILD_HINZUFUEGEN_FEHLER;
        constructor(public payload: any, public aufgabeBildRequest: api.AufgabeBildRequest, public optPayload: any = null) {}
    }
export class PostAufgabeBildHinzufuegenNichtAusgefuehrtAction implements Action {
    readonly type = POST_AUFGABE_BILD_HINZUFUEGEN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type VorlagenCommandAufgabeBildHinzufuegenActions =
    PostAufgabeBildHinzufuegenAction
    | PostAufgabeBildHinzufuegenAusfuehrenAction
    | PostAufgabeBildHinzufuegenErfolgreichAction
    | PostAufgabeBildHinzufuegenFehlerAction
    | PostAufgabeBildHinzufuegenNichtAusgefuehrtAction
    ;
